var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : new P(function (resolve) { resolve(result.value); }).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import React, { useContext, useEffect } from 'react';
import { PrivateContext } from './IdentityProvider';
import PostAuthCallback from './PostAuthCallback';
function completeAuthentication({ authService, postAuthCallback, privateDispatch }) {
    return __awaiter(this, void 0, void 0, function* () {
        let user;
        try {
            user = yield authService.completeAuthentication();
            PostAuthCallback({ postAuthCallback, privateDispatch, user });
        }
        catch (error) {
            console.log(`Unable to complete authentication from OpenID Connect: ${error}.`);
        }
        finally {
            window.location.hash = '';
        }
        if (!user) {
            privateDispatch({ type: 'BEGIN_REDIRECT', redirectTarget: '/' });
        }
    });
}
export default function OidcCallback() {
    const { privateState: { authService, debugMode, postAuthCallback }, privateDispatch } = useContext(PrivateContext);
    useEffect(() => {
        completeAuthentication({ authService, postAuthCallback, privateDispatch });
    }, []);
    if (debugMode === true) {
        return React.createElement("h1", null, "Processing response from Identity Server");
    }
    return null;
}
